/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'ai-mate.agent-header-banner-label': 'Baner agenta',
  'ai-mate.agent-list.all-agents-section-title': 'Wszystkie agenty',
  'ai-mate.agent-list.beta-lozenge-title': 'Wersja beta',
  'ai-mate.agent-list.change-owner-success-flag-description':
    'Zmieniono właściciela agenta {agentName} na {newOwnerName}',
  'ai-mate.agent-list.change-owner-success-flag-title': 'Zmiana właściciela powiodła się',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Czy na pewno chcesz usunąć tego agenta? Tej czynności nie można cofnąć.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Usunąć agenta „{agentName}”?',
  'ai-mate.agent-list.delete-agent-error': 'Nie można usunąć agenta',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    'Coś poszło nie tak podczas usuwania agenta. Spróbuj ponownie za chwilę.',
  'ai-mate.agent-list.delete-agent-error-flag-title': 'Nie można usunąć agenta',
  'ai-mate.agent-list.delete-agent-error.agent-in-use': 'Agent jest obecnie używany. Spróbuj ponownie później.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'Nie można znaleźć tego agenta.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'Nie możesz usuwać agentów nieutworzonych przez Ciebie. Skontaktuj się z właścicielem agenta.',
  'ai-mate.agent-list.delete-agent-success-flag-description': 'Usunięto {agentName}',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Usunięto agenta',
  'ai-mate.agent-list.development-section-title': 'Agenty programistyczne',
  'ai-mate.agent-list.recommended-agents-section-title': 'Polecane',
  'ai-mate.agent-list.templates-description':
    'Użyj tych szablonów, aby utworzyć własnego agenta programowania. Wybierz odpowiedni szablon agenta dla swojej pracy, wybierz opcję Użyj szablonu, a następnie wypełnij monit szablonu określonymi szczegółami, takimi jak repozytorium, folder, język i biblioteka. Utwórz dostosowanych do swoich potrzeb agentów do programowania różnych zadań, projektów lub repozytoriów.',
  'ai-mate.agent-list.templates-lozenge-title': 'Szablon',
  'ai-mate.agent-list.templates-title': 'Szablony programowania',
  'ai-mate.agent-message.agent-not-found': 'Nie znaleziono agenta',
  'ai-mate.agent-message.convo-title':
    'Czat z agentem {agentName} uruchomiony z poziomu obiektu osadzonego inteligentnego łącza',
  'ai-mate.agent-message.copy-link': 'Kopiuj łącze agenta',
  'ai-mate.agent-message.prompt': 'Prompt',
  'ai-mate.agent-message.prompt-placeholder': 'Wpisz wiadomość do agenta {agentName}',
  'ai-mate.agent-message.prompt-submit': 'Prześlij',
  'ai-mate.agent-message.view-profile': 'Wyświetl profil',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Anuluj',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Usuń',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agent · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Porozmawiaj z agentem {agentName}',
  'ai-mate.agent-profile-info.hidden-icon': 'Ukryte',
  'ai-mate.agent-profile-info.hidden-tooltip': 'Agent nie wyświetli się w wynikach wyszukiwania',
  'ai-mate.agent-profile-info.star-agent-tooltip': 'Oznacz agenta gwiazdką',
  'ai-mate.agent-selector.default-agent-description':
    'Uzyskuj odpowiedzi, generuj nowe pomysły i przyspiesz codzienną pracę.',
  'ai-mate.agent-selector.default-agent-name': 'Czat',
  'ai-mate.profile-card-preview.actions-title': 'Czynności',
  'ai-mate.profile-card-preview.agent-default-title': 'Agent',
  'ai-mate.profile-card-preview.agent-description-label': 'Opis',
  'ai-mate.profile-card-preview.agent-title-label': 'Tytuł',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Rozpoczynanie rozmowy',
  'ai-mate.profile-card-preview.empty-actions': 'Brak',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'Brak',
  'ai-mate.profile-card-preview.empty-instructions': 'Brak',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'Brak wyboru',
  'ai-mate.profile-card-preview.instructions-title': 'Instrukcje',
  'ai-mate.profile-card-preview.knowledge-title': 'Wiedza',
  'ai-mate.profile-card-preview.regenerate-label': 'Wygeneruj ponownie {fieldName}',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} — kopia',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label':
    'Przeciągnij, aby zmienić kolejność',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': 'Nie można zapisać zmian',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Wystąpił nieznany błąd. Spróbuj ponownie',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'Agent o tej nazwie już istnieje',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Usuń',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text':
    'Generuj sformułowania rozpoczynające rozmowę',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {{fieldName} nie może przekraczać {maxLength,number} znaku} few {{fieldName} nie może przekraczać {maxLength,number} znaków} many {{fieldName} nie może przekraczać {maxLength,number} znaków} other {{fieldName} nie może przekraczać {maxLength,number} znaku}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Dalej',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Uruchom ponownie',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': 'Przejdź do konfiguracji ręcznej',
  'create-agent.owner-field.confirm-modal-cancel': 'Anuluj',
  'create-agent.owner-field.confirm-modal-confirm': 'Tak, kontynuuj',
  'create-agent.owner-field.confirm-modal-content':
    'Zamierzasz zmienić właściciela tego agenta na {name}. Uniemożliwi Ci to edytowanie tego agenta lub zarządzanie nim.',
  'create-agent.owner-field.confirm-modal-title': 'Wkrótce stracisz dostęp do edycji',
  'create-agent.owner-field.owner-description': 'Jest to osoba, która może edytować agenta lub zarządzać nim.',
  'create-agent.owner-field.owner-label': 'Właściciel',
  'rovo-chat.agent-card.deactivated-name': '{name} (dezaktywowany)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'Zbyt wiele żądań. Poczekaj chwilę.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Spróbuj ponownie',
  'rovo-chat.browse-agents.all-agents-button': 'Wszystkie',
  'rovo-chat.browse-agents.close-button': 'Zamknij',
  'rovo-chat.browse-agents.create-agent-button': 'Utwórz',
  'rovo-chat.browse-agents.create-an-agent-button': 'Tworzenie agenta',
  'rovo-chat.browse-agents.created-by-label': '<text>autor:</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Agenty kodowania',
  'rovo-chat.browse-agents.favorite-agents-button': 'Ulubione',
  'rovo-chat.browse-agents.favourited-agent-label': 'Agent dodany do ulubionych',
  'rovo-chat.browse-agents.learn-more': 'Dowiedz się więcej',
  'rovo-chat.browse-agents.modal-title': 'Przeglądaj agentów',
  'rovo-chat.browse-agents.my-agents-button': 'Moi agenci',
  'rovo-chat.browse-agents.no-created-agents':
    'Wygląda na to, że nie utworzono jeszcze żadnych agentów. Zacznij od zduplikowania innych istniejących agentów lub utwórz agenta od podstaw.',
  'rovo-chat.browse-agents.no-created-agents-header': 'Nie utworzono jeszcze żadnych Agentów',
  'rovo-chat.browse-agents.no-results': 'Brak wyników',
  'rovo-chat.browse-agents.no-starred-agents':
    'Oznacz gwiazdką ulubionego lub często wykorzystywanego agenta, aby mieć do niego łatwy dostęp.',
  'rovo-chat.browse-agents.no-starred-agents-header': 'Brak agentów oznaczonych gwiazdką',
  'rovo-chat.browse-agents.search-input.placeholder': 'Wyszukaj agenty',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Szukaj szablonów',
  'rovo-chat.browse-agents.see-all-agents-button': 'Wyświetl wszystkie agenty',
  'rovo-chat.browse-agents.starred-agents-button': 'Oznaczone gwiazdką',
  'rovo-chat.browse-agents.templates-button': 'Szablony',
  'rovo-chat.create-agent.actions-section-description':
    'Dodaj czynności umożliwiające agentowi wykonywanie zadań w Jirze, Confluence i Jira Service Management. <link>Czym są czynności agenta?</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'Dodaj czynności',
  'rovo-chat.create-agent.all-content-label': 'Cała zawartość',
  'rovo-chat.create-agent.back-button': 'Wstecz',
  'rovo-chat.create-agent.confirm-leave-modal.body': 'Nie utworzono jeszcze agenta. Czy chcesz go odrzucić?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Anuluj',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'Tak, odrzuć agenta',
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Niedokończony agent',
  'rovo-chat.create-agent.confirm-restart-modal.body': 'Czy na pewno chcesz odrzucić zmiany wprowadzone w tym agencie?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Potwierdź',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Ponowne uruchamianie tworzenia',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'Można ich użyć w celu rozpoczęcia czatu z agentem. Możemy je wygenerować dla Ciebie, jeśli nic nie przychodzi Ci do głowy.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Rozpoczynanie rozmowy',
  'rovo-chat.create-agent.create-agent-button': 'Utwórz',
  'rovo-chat.create-agent.ctions-section-title': 'Czynności',
  'rovo-chat.create-agent.description-field-description':
    'Użytkownicy mogą skorzystać z opisu w profilu Agenta, aby dowiedzieć się więcej na jego temat.',
  'rovo-chat.create-agent.description-field-label': 'Opis',
  'rovo-chat.create-agent.description-field-placeholder':
    'Opisz agenta w kilku słowach (np. kreatywny autor blogów marketingowych)',
  'rovo-chat.create-agent.instructions-field-description':
    'Jakiego zachowania oczekujesz od tego agenta? Co potrafi robić? <link>Więcej informacji o pisaniu instrukcji dla agenta</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Instrukcje',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Dostosuj instrukcje dla tego agenta',
  'rovo-chat.create-agent.intro-description-part-1':
    'Utwórz agenta ze specjalistyczną wiedzą, który będzie odpowiadał na pytania, pisał i sprawdzał treści oraz wykonywał zadania, pomagając Ci w realizacji prac.',
  'rovo-chat.create-agent.intro-description-part-2':
    'Jeśli nie potrzebujesz pomocy, możesz <bold>przejść do konfiguracji ręcznej</bold>.',
  'rovo-chat.create-agent.intro-description-part-3': 'W przeciwnym razie zostań tutaj i utworzymy agenta wspólnie.',
  'rovo-chat.create-agent.intro-step-1-content':
    'Na podstawie tego, co napiszesz, utworzę instrukcje dla agenta. Po prostu określ, do czego zamierzasz używać agenta.',
  'rovo-chat.create-agent.intro-step-1-title': 'Opisz, co ma robić agent',
  'rovo-chat.create-agent.intro-step-2-content':
    'Wspólnie wybierzmy nazwę i osobowość dla agenta. Napisz, czy agent ma być empatyczny, bezpośredni, czy zabawny.',
  'rovo-chat.create-agent.intro-step-2-title': 'Nadaj mu charakteru',
  'rovo-chat.create-agent.intro-step-3-content':
    'Kliknij przycisk <bold>Dalej</bold>, aby przejrzeć nowego agenta oraz dodać czynności, wiedzę i zdjęcie profilowe. Po zakończeniu kliknij przycisk <bold>Utwórz</bold>.',
  'rovo-chat.create-agent.intro-step-3-title': 'Przejrzyj i utwórz agenta',
  'rovo-chat.create-agent.intro-title': '👋 Utwórzmy Twojego agenta',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'Wszystkie projekty',
  'rovo-chat.create-agent.knowledge-field-description':
    'Określ zakres wiedzy agenta, pozwalając mu odwoływać się tylko do podanych źródeł',
  'rovo-chat.create-agent.knowledge-field-label': 'Wiedza',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Odwołuj się tylko do tych źródeł',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Sugerowane',
  'rovo-chat.create-agent.manage-actions-button-label': 'Zarządzaj czynnościami',
  'rovo-chat.create-agent.name-field-description': 'Można jej używać, aby znaleźć agenta.',
  'rovo-chat.create-agent.name-field-label': 'Nazwa',
  'rovo-chat.create-agent.name-field-placeholder': 'Nazwij agenta',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error':
    'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    'Cześć! Jestem tutaj, aby pomóc Ci utworzyć niestandardowego agenta. Napisz, co ma robić Twój agent.',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Wpisz wiadomość',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Wyślij',
  'rovo-chat.create-agent.page-title': 'Tworzenie agenta',
  'rovo-chat.create-agent.page-title-edit': 'Edytuj agenta',
  'rovo-chat.create-agent.search-for-pages-placeholder': 'Wyszukiwanie stron',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Wyszukiwanie przestrzeni',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'Wszystkie',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Wersja beta',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Anuluj',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Zamknij',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, one {Wybór mniej niż {count,number} czynności zapewni optymalną wydajność} few {Wybór mniej niż {count,number} czynności zapewni optymalną wydajność} many {Wybór mniej niż {count,number} czynności zapewni optymalną wydajność} other {Wybór mniej niż {count,number} czynności zapewni optymalną wydajność}}',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Zapisz',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Wyszukaj czynności',
  'rovo-chat.create-agent.select-action-modal-title': 'Dodawanie czynności',
  'rovo-chat.create-agent.select-content-under-label': 'Wybierz treści w',
  'rovo-chat.create-agent.select-spaces-label': 'Wybór przestrzeni',
  'rovo-chat.create-agent.selected-actions-label': 'Wybrane czynności:',
  'rovo-chat.create-agent.unknown-owner': 'Nieznany',
  'rovo-chat.create-agent.update-agent-button': 'Aktualizuj',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    'Jeśli będziesz kontynuować, stracisz niezapisane zmiany. Wybierz opcję Anuluj, aby kontynuować edycję tego agenta.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Kontynuuj, odrzuć zmiany',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Odrzuć zmiany',
  'rovo-chat.view-agent.about-label': 'Informacje',
  'rovo-chat.view-agent.actions-label': 'Czynności',
  'rovo-chat.view-agent.beta-label': 'Wersja beta',
  'rovo-chat.view-agent.beta-tag': 'Beta',
  'rovo-chat.view-agent.chat-to-agent-button': 'Czat z agentem',
  'rovo-chat.view-agent.close-button': 'Zamknij',
  'rovo-chat.view-agent.copy-instructions-label': 'Kopiuj',
  'rovo-chat.view-agent.copy-instructions-tooltip': 'Kopiuj instrukcje',
  'rovo-chat.view-agent.created-by-label': '<text>twórca:</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': 'Liczba ulubionych',
  'rovo-chat.view-agent.go-back-label': 'Wstecz',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Zbudowane na podstawie kodu agenty Forge mają ukryte instrukcje w celu ochrony prywatności.',
  'rovo-chat.view-agent.hidden-instructions-title': 'Te instrukcje są prywatne',
  'rovo-chat.view-agent.hidden-knowledge-description':
    'Zbudowane na podstawie kodu agenty Forge nie korzystają z typowych źródeł wiedzy.',
  'rovo-chat.view-agent.instructions-label': 'Instrukcje',
  'rovo-chat.view-agent.knowledge-label': 'Wiedza',
  'rovo-chat.view-agent.member-count':
    '{count, plural, one {{count,number} członek} few {{count,number} członków} many {{count,number} członków} other {{count,number} członka}}',
  'rovo-chat.view-agent.modal-title': 'Przeglądaj agenty',
  'rovo-chat.view-agent.no-actions': 'Brak czynności',
  'rovo-chat.view-agent.no-instruction-placeholder': 'Ten agent nie ma instrukcji niestandardowych',
  'rovo-chat.view-agent.no-knowledge-added': 'Brak niestandardowych źródeł wiedzy',
  'rovo-chat.view-agent.no-teams': 'Nie należy do żadnego zespołu',
  'rovo-chat.view-agent.open-chat-label': 'Otwórz czat',
  'rovo-chat.view-agent.reactions-metadata-label': 'Liczba reakcji',
  'rovo-chat.view-agent.rovo-agent-label': 'Agent Rovo',
  'rovo-chat.view-agent.teams-label': 'Zespoły',
  'rovo-chat.view-agent.users-metadata-label': 'Liczba użytkowników',
};
